import { environment, endpoints } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Transfer } from '../models/transfer';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { Auth } from '../../autentication/Auth';
import * as moment from 'moment';
import { AccountNumberPipe } from '../../shared/account-number.pipe';
import { CpfCnpjPipe } from '../../shared/cpf-cnpj.pipe';
import { BenefactorDataModel } from '../models/benefactorData';
import { Util } from '../../utils/util';

@Injectable()
export class TransfersOmniService {

	public scheduleSpan: boolean;


	constructor(private http: HttpClient) { }

	sendTransfer(transfer: Transfer): Observable<any> {

		let _date = null;
		const accNumPipe = new AccountNumberPipe();

		if (transfer.dateType !== 'today') {
			_date = moment(transfer.date).format('YYYY/MM/DD');
		}

		const transferData = {
			CodAgenciaOrigem: Auth.getInstance().getUser().agency,
			CodContaOrigem: Auth.getInstance().getUser().accountNumber,
			CodAgenciaDestino: Auth.getInstance().getUser().agency,
			CodContaDestino: transfer.destinationAccount,
			DescBancoDestino: 'Omni Banco S.A.',
			CodBancoDestino: '613',
			Valor: transfer.value,
			Descricao: transfer.description,
			DataAgendamento: _date,
			CPFSolicitante: Auth.getInstance().getUser().cpf,
			Nome: Auth.getInstance().getUser().loggedUserName,
		};

		return this.http.post( endpoints.transfers.betweenAccounts, transferData ).pipe( map( (data: any) => {

			return data;

		}));

	}

	confirmTransfer(transferId: number, transferType: string, favoredRemember: boolean): Observable<any> {
		const requestId = Util.generateUUID4();
		
		return this.http.post( endpoints.transfers.betweenAccountsV3 +
			transferId +
			endpoints.confirmation + '/' +
			requestId + '/' +
			favoredRemember, {})
			.pipe( map( (data: any) => {
				return data;
		}));
	}

	getBenefactors() {
		return this.http.get( endpoints.benefactors.all + '?tipoFavorecido=omni', {}).pipe( map( (data: any) => {
			const CP = new CpfCnpjPipe();

			let benefactors: Array<BenefactorDataModel> = [];

			if (data.Sucesso) {

				data.Retorno.map(item => {

					let benefactor: BenefactorDataModel = new BenefactorDataModel();

					benefactor = item.Contas.map(itemAccount => {

						let modalityAll: string;

						switch (itemAccount.TpConta) {
							case 'CC':
								modalityAll = 'Conta Corrente';
								break;
							case 'PP':
								modalityAll = 'Conta Poupança';
								break;
							case 'PG':
								modalityAll = 'Conta Pagamento';
								break;
						}

						benefactor = {
							name: item.Titular,
							cpfCnpj: CP.transform(item.CpfCnpj),
							id: itemAccount.Id,
							agency: itemAccount.Agencia,
							accountNumber: itemAccount.NroConta.replace(/^(\d{0,13})*(\d{1})/, '$1-$2'),
							bankCode: itemAccount.Banco,
							bankDesc: itemAccount.NomeBanco,
							modality: itemAccount.TpConta,
							modalityAll: modalityAll
						}

						benefactors.push(benefactor);
					});
				});

				return benefactors;
			}

		}));
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-omni/transfers-omni.service.ts